import React, { useEffect, useRef, useState } from 'react';
import Button from '../../ui/Button';
import { observationFileAcceptString } from './observationFileUtils';

const ObservationFileAttachControl = ({
  disabled = false,
  uploading = false,
  label = 'Adjuntar archivo',
  onFileSelect
}) => {
  const inputRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [dragActive, setDragActive] = useState(false);

  useEffect(() => {
    if (disabled || uploading) {
      setExpanded(false);
      setDragActive(false);
    }
  }, [disabled, uploading]);

  const handleFile = (file) => {
    if (!file || disabled || uploading) return;

    const accepted = onFileSelect?.(file);
    if (accepted !== false) {
      setExpanded(false);
      setDragActive(false);
      if (inputRef.current) {
        inputRef.current.value = '';
      }
    }
  };

  const showDropzone = expanded || dragActive;

  return (
    <div
      className="approved-requests-page__file-attach"
      onDragEnter={(event) => {
        if (disabled || uploading) return;
        event.preventDefault();
        event.stopPropagation();
        setDragActive(true);
      }}
      onDragOver={(event) => {
        if (disabled || uploading) return;
        event.preventDefault();
        event.stopPropagation();
        setDragActive(true);
      }}
      onDragLeave={(event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!event.currentTarget.contains(event.relatedTarget)) {
          setDragActive(false);
        }
      }}
      onDrop={(event) => {
        event.preventDefault();
        event.stopPropagation();
        setDragActive(false);
        handleFile(event.dataTransfer.files?.[0]);
      }}
    >
      <input
        ref={inputRef}
        type="file"
        className="d-none"
        accept={observationFileAcceptString}
        disabled={disabled || uploading}
        onChange={(event) => {
          handleFile(event.target.files?.[0]);
        }}
      />

      <Button
        type="button"
        variant="secondary"
        size="sm"
        disabled={disabled || uploading}
        onClick={() => {
          if (showDropzone) {
            inputRef.current?.click();
            return;
          }

          setExpanded(true);
          inputRef.current?.click();
        }}
      >
        <i className="bi bi-paperclip" aria-hidden />
        {label}
      </Button>

      {showDropzone && (
        <div
          className={`approved-requests-page__file-dropzone approved-requests-page__file-dropzone--compact${dragActive ? ' approved-requests-page__file-dropzone--active' : ''}${disabled ? ' approved-requests-page__file-dropzone--disabled' : ''}`}
          role="presentation"
        >
          <i className="bi bi-cloud-upload approved-requests-page__file-dropzone-icon" aria-hidden />
          <div className="approved-requests-page__file-dropzone-copy">
            <strong>Soltá el archivo acá</strong>
            <span>PDF, JPG o PNG hasta 10 MB.</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ObservationFileAttachControl;
